export default __webpack_public_path__ + "static/media/qr_code_1.b87cfa27.png";